import React from 'react';
import ReactDOM from 'react-dom';
import {Observable, from, concat} from 'rxjs'
import {pluck, flatMap} from 'rxjs/operators'
import {fetchFeatureToggles} from 'feature-toggles!sofe';

export function sendBulkEmail(options) {
  if (typeof options !== 'object') {
    throw new Error(`Cannot send bulk email without an options object`);
  }

  if (!options.jql) {
    throw new Error(`Cannot send bulk email without options.jql`);
  }

  const el = document.createElement('div');
  document.body.appendChild(el);


  return concat(from(fetchFeatureToggles('ft_email_sharing')), from(import(/* webpackChunkName: "send-bulk-email" */'./send-bulk-email.component.js')).pipe(
    pluck('default'),
    flatMap(SendBulkEmail => {
      return Observable.create(observer => {
        ReactDOM.render(
          <SendBulkEmail
            options={options}
            finish={() => finished(true)}
            cancel={() => finished(false)}
            updatedContacts={updatedContacts}
          />,
          el
        );

        function finished(sent) {
          ReactDOM.unmountComponentAtNode(el);
          if (document.body.contains(el)) {
            document.body.removeChild(el);
          }
          observer.next({sent});
          observer.complete();
        }

        function updatedContacts() {
          // So that the contact list knows to refresh its list.
          observer.next({updatedContacts: true});
        }
      })
    })
  ))
}
